import axios from 'axios';
import config from '../../constants/apiConfig';

type Base64PdfString = string;

export type ExportAsFormParams = {
  formname: string;
  data?: any;
  mapSketch: any;
  periodNumber?: number;
};

export type ExportAsFormDeps = {
  incident: unknown;
  user: unknown;
  groupGuid: string;
};

/**
 * POST exportAsForm — used by IcsFormPdfPreviewProvider for preview + optional
 * download.
 */
export type PersistIcsFormExportPayload = {
  pdfBase64: string;
  workspaceFormname: string;
  periodNumber?: number;
};

export async function postPersistIcsFormExport(
  deps: ExportAsFormDeps,
  payload: PersistIcsFormExportPayload
): Promise<void> {
  const formData = new FormData();
  formData.append('pdfBase64', payload.pdfBase64);
  formData.append('formname', payload.workspaceFormname);
  formData.append('incident', JSON.stringify(deps.incident));
  if (payload.periodNumber != null) {
    formData.append('periodNumber', String(payload.periodNumber));
  }

  await axios.post(config.apiGateway.persistIcsFormExport, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function postExportAsForm(
  deps: ExportAsFormDeps,
  { formname, data = {}, mapSketch, periodNumber }: ExportAsFormParams
): Promise<{ formname: string; data: string }> {
  const formData = new FormData();
  if (mapSketch !== undefined && mapSketch !== null) {
    formData.append('file', mapSketch);
  }
  formData.append('data', JSON.stringify(data));
  formData.append('formname', formname);
  formData.append('incident', JSON.stringify(deps.incident));
  formData.append('user', JSON.stringify(deps.user));
  formData.append('group_guid', deps.groupGuid);
  formData.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
  if (periodNumber !== undefined) {
    formData.append('periodNumber', String(periodNumber));
  }

  const response = await axios.post<Base64PdfString>(
    config.apiGateway.exportAsForm,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
  );
  return { formname, data: response.data || '' };
}
